import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { api } from "../lib/api.ts";
import { useT } from "../lib/i18n.ts";
import { Ic } from "../components/Icons.tsx";

/**
 * Connected services (round 5c): the accounts Instead is linked to, in one
 * place — today the AI assistant (the MCP connector) alone. Google is the
 * account itself and lives nowhere else; the Spotify connection went with
 * D-39 (Spotify links are public lookups, no account needed).
 */
export function ConnectedServices() {
  const t = useT();
  const nav = useNavigate();
  const { data: ai } = useQuery({ queryKey: ["ai"], queryFn: api.ai.status });

  return (
    <div>
      <div className="screen-head">
        <button className="icon-btn" aria-label={t("back")} onClick={() => nav({ to: "/settings" })}>{Ic.back()}</button>
        <h1 className="title">{t("settings.services")}</h1>
      </div>

      <section className="settings-group" aria-labelledby="svc-ai">
        <h2 id="svc-ai">{t("settings.ai")}</h2>
        <Link className="nav-row" to="/connect">
          <span className="grow">{t("settings.ai.connect")}</span>
          <span className="meta">{ai?.connected ? t("connect.connected") : t("services.notConnected")}</span>
          <span style={{ color: "var(--ink-3)", display: "inline-flex" }}>{Ic.chevron({ size: 16 })}</span>
        </Link>
      </section>
    </div>
  );
}
